import React from 'react';
import { IDeviceChannel } from 'lavva.exalushome/build/js/Services/Devices/IDeviceChannel';
import { IconCalibrateInfo } from '../../../../../assets/icons/calibrate-info';
import { IconConnectionError } from '../../../../../assets/icons/icon-connection-error';
import { useSomethingWrong } from '../../channel-list/hooks/use-something-wrong';

type ChannelDetailsErrorIconsProps = {
  channel: IDeviceChannel;
};

export const ChannelDetailsErrorIcons: React.FC<ChannelDetailsErrorIconsProps> = ({ channel }) => {
  const { connectionIcon, calibrationNeed } = useSomethingWrong(channel);

  return connectionIcon ? <IconConnectionError size={9} details /> : calibrationNeed ? <IconCalibrateInfo /> : null;
};
